import { verifyAddress } from '../../../smartpak/qas';
import { newsLetterSubscriptionEvent, signUpEvent as dySignUpEvent } from '../../../vendor/dynamicyield/dynamicyield';
import { signup as reCaptchaSignUp } from '../../../vendor/recaptcha/recaptcha';
import registrationForm from './registrationform';
import * as fields from './formfields';
import { spSignUp } from '../../../vendor/googletagmanager/spevents/spsignup';
import { beginGuestCheckout, getCartItems, isGuestFromCart } from './guest';

function asyncVerifyAddress($form) {
    return new Promise(res => verifyAddress($($form), () => res()));
}

function htmlEncodeText($element) {
    $element.innerHTML = $element.innerText;
}

function convertErrorStringToHTML() {
    [...document.querySelectorAll('.validation-summary-errors li')].forEach($item => htmlEncodeText($item));
}

function validationErrorsContain(str) {
    const $validation = document.querySelector('.validation-summary-errors');

    return $validation && $validation.textContent.includes(str);
}

function isCreationPage(search) {
    const params = new URLSearchParams(search);
    const name = 'create';

    return params.has(name) && params.get(name) === 'true';
}

const $form = document.getElementById('registerme');
const formdata = Object.fromEntries((new FormData($form)).entries());

registrationForm({
    $form,
    showPasswordFields: formdata?.ShowSaveMyInformationSection === 'False' || isCreationPage(location.search) || validationErrorsContain('password'),
    asyncVerifyAddress,
    tokenService: reCaptchaSignUp,
    onRegister: async data => {
        spSignUp();
        dySignUpEvent(data[fields.Email_Address]);

        if ($form.querySelector('#SendMeHorseAndRiderPromotionsAndShoppingSpree')?.checked) {
            newsLetterSubscriptionEvent(data[fields.Email_Address]);
        }

        if (isGuestFromCart({ referrer: document.referrer, search: location.search })) {
            const cartItems = await getCartItems();

            if (Array.isArray(cartItems)) {
                beginGuestCheckout(cartItems);
            }
        }
    }
});

convertErrorStringToHTML();